import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  messages: [],
  pendingPrompt: null,
  nextMessageId: 1,
};

export const aiAssistantSlice = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    aiAssistantOpen: (state, action) => {
      state.isOpen = true;
      if (action.payload) state.pendingPrompt = action.payload;
    },
    aiAssistantClose: (state) => {
      state.isOpen = false;
      state.pendingPrompt = null;
    },
    aiAssistantClearPendingPrompt: (state) => {
      state.pendingPrompt = null;
    },
    aiAssistantSetMessages: (state, action) => {
      state.messages = action.payload;
    },
    aiAssistantAppendMessages: (state, action) => {
      state.messages.push(...action.payload);
    },
    aiAssistantUpdateMessage: (state, action) => {
      const { id, patch } = action.payload;
      const idx = state.messages.findIndex((m) => m.id === id);
      if (idx !== -1) state.messages[idx] = { ...state.messages[idx], ...patch };
    },
    aiAssistantReserveMessageIds: (state, action) => {
      state.nextMessageId += action.payload;
    },
    aiAssistantReset: () => initialState,
    aiAssistantHydrate: (state, action) => {
      const { messages, nextMessageId } = action.payload || {};
      if (Array.isArray(messages)) state.messages = messages;
      if (typeof nextMessageId === 'number' && nextMessageId > state.nextMessageId) {
        state.nextMessageId = nextMessageId;
      }
    },
  },
});

export const {
  aiAssistantOpen,
  aiAssistantClose,
  aiAssistantClearPendingPrompt,
  aiAssistantSetMessages,
  aiAssistantAppendMessages,
  aiAssistantUpdateMessage,
  aiAssistantReserveMessageIds,
  aiAssistantReset,
  aiAssistantHydrate,
} = aiAssistantSlice.actions;

export const selectAiAssistantIsOpen = (state) => state.aiAssistant.isOpen;
export const selectAiAssistantMessages = (state) => state.aiAssistant.messages;
export const selectAiAssistantPendingPrompt = (state) => state.aiAssistant.pendingPrompt;
export const selectAiAssistantNextMessageId = (state) => state.aiAssistant.nextMessageId;

export default aiAssistantSlice.reducer;
